import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App.jsx";
import { Overview } from "./pages/Overview.jsx";
import { Posts } from "./pages/Posts.jsx";
import { Competitors } from "./pages/Competitors.jsx";
import { Trending } from "./pages/Trending.jsx";
import { Draft } from "./pages/Draft.jsx";
import { Newsletter } from "./pages/Newsletter.jsx";
import { Settings } from "./pages/Settings.jsx";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 }
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Overview />} />
            <Route path="posts" element={<Posts />} />
            <Route path="competitors" element={<Competitors />} />
            <Route path="trending" element={<Trending />} />
            <Route path="draft" element={<Draft />} />
            <Route path="newsletter" element={<Newsletter />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
